<template>
  <div class="page page-prescriptions">
    <PrescriptionList
      v-if="!prescription"
      title="Текущие назначения"
      :list="current"
      :selectPrescription="selectPrescription"
      :mute="false" />

    <PrescriptionList
      v-if="!prescription"
      title="Прошлые назначения"
      :list="past"
      :selectPrescription="selectPrescription"
      :mute="true" />

    <PrescriptionStart
      v-if="prescription"
      :prescription="prescription"
      :selectPrescription="selectPrescription"
      :startPrescription="startPrescription" />
  </div>
</template>

<script>
  import PrescriptionList from './prescription/List';
  import PrescriptionStart from './prescription/Start';

  export default {
    name: 'Prescription',

    components: { PrescriptionList, PrescriptionStart },

    data() {
      return {
        prescriptionId: null,
      };
    },

    computed: {
      current() {
        return this.getPrescriptionsByCatalogs(
          this.list.filter(item => !item.isFinished)
        );
      },

      past() {
        return this.getPrescriptionsByCatalogs(
          this.list.filter(item => item.isFinished)
        );
      },

      list() {
        const now = Date.now();
        const prescriptions = this.$store.state.prescriptions.map(p => {
          const startDateMs = (new Date(p.startDate)).getTime();
          const finishDateMs = (new Date(p.finishDate)).getTime();
          const diffMs = finishDateMs - startDateMs;
          const endAtTs = p.startedAt
            ? (new Date(p.startedAt)).getTime() + diffMs
            : finishDateMs;
          const isFinished = now > endAtTs && p.startedAt !== null;

          return {
            id: p.id,
            drug: p.drug,
            startDate: p.startDate,
            finishDate: p.finishDate,
            quantity: p.quantity,
            times: p.times,
            startedAt: p.startedAt,
            comment: p.comment,
            endAtTs,
            isFinished
          };
        });

        prescriptions.sort((a, b) => b.endAtTs - a.endAtTs);

        return prescriptions;
      },

      prescription() {
        return this.list.find(item => item.id === this.prescriptionId);
      },
    },

    methods: {
      getPrescriptionsByCatalogs(prescriptions) {
        const catalogs = {};

        prescriptions.forEach(prescription => {
          const catalog = prescription.drug.ingredient.catalog;

          if (typeof catalogs[catalog.id] === 'undefined') {
            catalogs[catalog.id] = { catalog, prescriptions: [] };
          }

          catalogs[catalog.id].prescriptions.push(prescription)
        });

        return catalogs;
      },

      selectPrescription(id) {
        this.prescriptionId = id;
      },

      async startPrescription(drugPrescriptionId, startDate) {
        try {
          const data = { drugPrescriptionId, startDate };

          await this.$store.dispatch('START_PRESCRIPTION', data);

          this.selectPrescription(null);
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page-prescriptions {
    padding-bottom: 10px;
    position: relative;

    .prescription-list {
      margin: 0 0 10px;

      .prescription-catalog {
        position: relative;
        padding: 10px 15px;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        color: $primary;
        background-color: $light-gray-bg;
        border-top: 2px solid $primary;
      }
    }
  }
</style>
